import React, { useEffect, useState } from "react";
import { gerarToken, getMonitoramentoBackup } from "../api/apiPainel";
import { format, parseISO } from "date-fns";
import "../styles/PainelMonitoramento.css";
import inativo from '../assets/1.png';
import ativo from '../assets/2.png';

const PainelMonitoramentoBackup: React.FC = () => {
  const [servicos, setServicos] = useState([]);
  const fetchData = async () => {
    try {
      const data = await getMonitoramentoBackup();
      setServicos(data);
    } catch (error) {
      console.error("Erro ao buscar serviços monitorados:", error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        await gerarToken();
        fetchData();
        const intervalId = setInterval(fetchData, 10000);
        return () => clearInterval(intervalId);
      } catch (error) {
        console.log("Erro ao inicializar:", error);
      }
    };
    initialize();
  }, []);

  return (
    <>      
      <div className="titulo">
        <h1>Monitoramento de Backups (SMB)</h1>
      </div>
      <div className="table-container">
        <table className="table-action">
          <thead>
            <tr>
              <th >Nome do Banco</th>
              <th >Backup Realizado</th>
              <th className="break-line">Data de Referência</th>
            </tr>
          </thead>
          <tbody>
            {servicos.map((servico: any) => (
              <tr className="linha-marcada" key={servico.cdMonitoramentoBackup}>
                <td data-label="Nome do Banco">{servico.nmBancoMonitorado}</td>
                <td data-label="Backup Realizado">
                  <div className="campo-luz-de-aviso-backup">
                    <img className="luz-de-aviso" src={servico.dmBackupExiste ? ativo : inativo} alt="Status Ativo" />
                  </div>
                </td>                
                <td data-label="Data de Referência" >
                  <div className="verificacao">
                    {servico.dtBackupReferencia ? format(parseISO(servico.dtBackupReferencia), "dd/MM/yyyy") : "Data não disponível"}
                  </div></td>                
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <br />
    </>
  );
};

export default PainelMonitoramentoBackup;
